import { TranslateService } from "@ngx-translate/core";

import { Key, Row } from "./tabbed-detail-container.types";

type EntityWithDescription = { customerDescription?: string | null; description: string };

export function descriptionForEntity(entity: EntityWithDescription | null | undefined): string {
  return entity?.customerDescription || entity?.description || "-";
}

export function propertyKeysToRows(translate: TranslateService, keys: Key[], item: any): Row[] {
  if (!item) {
    return [];
  }

  const pathValue = (obj: any, path: string | string[]): any => {
    if (typeof path === "string") {
      return pathValue(obj, path.split("."));
    } else if (path.length === 0 || !obj) {
      return obj;
    }
    return pathValue(obj[path[0]], path.slice(1));
  };

  const propertyKeyToRowOrNull = (key: Key): Row | null => {
    let scalarValue = "";
    let objectValue = {};
    let arrayValue = [];

    if (!key.key || key.key.length === 0) {
      objectValue = item;
    } else {
      const path_value = pathValue(item, key.key);
      if (path_value === null || path_value === undefined) {
        return null;
      }
      if (Array.isArray(path_value)) {
        // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
        arrayValue = path_value;
      } else if (typeof path_value === "object") {
        objectValue = path_value;
      } else {
        scalarValue = path_value;
      }
    }

    if (scalarValue.toString().length === 0 && Object.keys(objectValue).length === 0 && arrayValue.length === 0) {
      return null;
    }

    return {
      title: translate.instant(key.title) || "-",
      display: key.display || "default",
      scalarValue,
      objectValue,
      arrayValue,
    };
  };

  // @ts-expect-error: There is a null/undefined/typing issue; please fix me!
  return keys
    .filter((key) => key.if !== false)
    .map(propertyKeyToRowOrNull)
    .filter((row) => row);
}
